exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.watermark_sprite-image_3ywoR {\n    margin: auto;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    max-width: 48px;\n    max-height: 48px;\n    opacity: 0.35;\n}\n", ""]);

// exports
exports.locals = {
	"sprite-image": "watermark_sprite-image_3ywoR",
	"spriteImage": "watermark_sprite-image_3ywoR"
};